export enum ProductTranslationType {
  DigitalProducts = 'DigitalProducts',
  SubscriptionProducts = 'SubscriptionProducts',
  ShippingMethods = 'ShippingMethods',
  Logistics = 'Logistics',
}
